<template>
  <div class="reset-pass">
    <div class="reset">
      <!-- 重置密码 -->
        <div class="reset_form" v-if="isreset">
          <!-- <p @click="back()"><i class="icon el-icon-arrow-left"></i>Back</p> -->
          <el-form :model="resetForm" :rules="resetValidate" ref="resetForm" label-width="100px" class="demo-resetForm">
            <h3>Reset Password</h3>
            <p>Current password</p>
            <el-form-item prop="currentPassword">
              <el-input :class="changeCurrentFlag == 1?'':'errorPass'" :type="resetForm.currentPwdType" v-model="resetForm.currentPassword" autocomplete="off"></el-input>
              <img :src="resetForm.currentSeen?openeye:nopeneye" class="eye" alt="" @click="changeType('currentSeen')">
            </el-form-item>
            <p>New password</p>
              <el-form-item prop="newPassword">
                <el-input :class="changeFlag == 1?'':'errorPass'" :type="resetForm.newPwdType" v-model="resetForm.newPassword" autocomplete="off"></el-input>
                <img :src="resetForm.NewSeen?openeye:nopeneye" class="eye" alt="" @click="changeType('NewSeen')">
              </el-form-item>
            <p>Confirm new password</p>
            <el-form-item prop="ConfirmNewPassword">
              <el-input :class="changeAgainFlag == 1?'':'errorPass'" :type="resetForm.confirmNewPwdType" v-model="resetForm.ConfirmNewPassword" autocomplete="off"></el-input>
              <img :src="resetForm.confirmNewSeen?openeye:nopeneye" class="eye" alt="" @click="changeType('confirmNewSeen')">
            </el-form-item>
            <el-button type="primary" @click="toReset()">Reset</el-button>
          </el-form>
        </div>
        <!-- savePass -->
        <div class="save_form" v-if="issave">
          <el-form label-width="100px" class="demo-forgetForm">
          <h3>New password is saved</h3>
          <p
            class="huo"
            @click="ToSign"
            >Back to Sign In page</p>
            <!-- <router-link :to="{name:'home'}"> -->
          </el-form>
        </div>
  </div>
  </div>
</template>
<script>
import store from '@/store/store'
import IndexHeader from './views/header'
export default {
  name: 'resetPassword',
  components: {
    IndexHeader
  },
  data () {
    // 原密码
    const currentpwdCheck = async (rule, value, callback) => {
      // let reg = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[~@#$%\*-\+=:,\\?\[\]\{}]).{6,16}$/
      let reg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,}$/
      if (value.length < 1) {
        this.changeCurrentFlag = 2
        return callback(new Error('Current password cannot be empty.'))
      // } else if (value.length > 16) {
      //   // this.changeFlag = 2;
      //   return callback(new Error('密码最长不能超过16位！'));
      } else if (!reg.test(value)) {
        this.changeCurrentFlag = 2
        return callback(new Error('Current password format is not correct.'))
      } else if (this.resetForm.newPassword == this.resetForm.currentPassword) {
        this.changeCurrentFlag = 2
        return callback(new Error('New password cannot be the same as current password.'))
      } else {
        this.changeCurrentFlag = 1
        callback()
      }
    }
    // 密码验证
    const pwdCheck = async (rule, value, callback) => {
      let reg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,}$/
      if (value.length < 1) {
        this.changeFlag = 2
        return callback(new Error('New password cannot be empty.'))
      // } else if (value.length < 8) {
        // this.changeFlag = 2;
        // return callback(new Error('New password cannot be less than 8 digits'));
      // } else if (value.length > 16) {
      //   // this.changeFlag = 2;
      //   return callback(new Error('密码最长不能超过16位！'));
      } else if (!reg.test(value)) {
        this.changeFlag = 2
        return callback(new Error('New password format is not correct.'))
      } else if (this.resetForm.newPassword == this.resetForm.currentPassword) {
        this.changeFlag = 2
        return callback(new Error('New password cannot be the same as current password.'))
      } else {
        this.changeFlag = 1
        callback()
      }
    }
    // 重复密码验证
    const pwdAgainCheck = async (rule, value, callback) => {
      if (value.length < 1) {
        this.changeAgainFlag = 2
        return callback(new Error('New password cannot be empty.'))
      } else if (this.resetForm.newPassword != this.resetForm.ConfirmNewPassword) {
        this.changeAgainFlag = 2
        return callback(new Error('Both new passwords do not match.'))
      } else {
        this.changeAgainFlag = 1
        callback()
      }
    }
    return {
      resetForm: {
        currentPassword: '',
        newPassword: '',
        ConfirmNewPassword: '',
        NewSeen: false,
        currentSeen: false,
        confirmNewSeen: false,
        currentPwdType: 'password',
        newPwdType: 'password',
        confirmNewPwdType: 'password'
      },
      resetValidate: {
        currentPassword: [
          { required: true, validator: currentpwdCheck, trigger: 'blur' }
        ],
        newPassword: [
          { required: true, validator: pwdCheck, trigger: 'blur' }
        ],
        ConfirmNewPassword: [
          { required: true, validator: pwdAgainCheck, trigger: 'blur' }
        ]
      },
      changeCurrentFlag: 1,
      changeFlag: 1,
      changeAgainFlag: 1,
      openeye: require('@/assets/eye.svg'), // 图片地址
      nopeneye: require('@/assets/eye-off.svg'), // 图片地址
      isreset: true,
      issave: false
    }
  },
  created () {
    if (!this.utils.getCookie('pc_token')) {
      this.$router.push({
        path: '/'
      })
    }
  },
  methods: {
    changeType (seen) {
      if (seen == 'currentSeen') {
        this.resetForm.currentPwdType = this.resetForm.currentPwdType === 'password' ? 'text' : 'password'
        this.resetForm.currentSeen = !this.resetForm.currentSeen
      } else if (seen == 'NewSeen') {
        this.resetForm.newPwdType = this.resetForm.newPwdType === 'password' ? 'text' : 'password'
        this.resetForm.NewSeen = !this.resetForm.NewSeen
      } else if (seen == 'confirmNewSeen') {
        this.resetForm.confirmNewPwdType = this.resetForm.confirmNewPwdType === 'password' ? 'text' : 'password'
        this.resetForm.confirmNewSeen = !this.resetForm.confirmNewSeen
      }
    },
    ToSign () {
      this.$router.push({ path: '/' })
    },
    back () {
      // if (window.history.length <= 1) {
      this.$router.push({ path: '/index' })
      // return false;
      // } else {
      // this.$router.go(-1);
      // }
    },
    toReset () {
      this.$http.post('/tutor/api/resetPassWord', {
        oldPassword: this.resetForm.currentPassword,
        newPassword: this.resetForm.newPassword,
        repeatPassword: this.resetForm.ConfirmNewPassword
      }).then((res) => {
        if (res.data.code == 200) {
          console.log(res)
          this.issave = !this.issave
          this.isreset = !this.isreset
          this.$message({
            message: res.data.msg,
            type: 'success'
          })
        } else {
          this.$message({
            message: res.data.msg,
            type: 'warning'
          })
        }
      }).catch((error) => {
        console.log(error) // 请求失败返回的数据
      })
    }
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
.reset{
  margin: 0 auto;
  overflow: inherit;
  background-image: url("../assets/border1@1x.png");
  background-position: bottom;
  height: calc(100vh - 64px);
  background-repeat: repeat-x;
  background-color: #FFF8D0;
  padding-top: 60px;
    p{
      font-size: 16px;
      font-family: Arial;
      color: #424347;
    }
    h3{
      font-size: 30px;
      font-family: Arial;
      font-weight: 700;
      color: #353643;
      margin-bottom: 38px;
    }

    .huo {
      font-size: 18px;
      font-family: Arial;
      font-weight: 700;
      text-decoration: underline;
      text-align: LEFT;
      color: #ff6440;
      cursor: pointer;
      margin-top:40px;
    }
    .save_form{
      .el-form{
        margin-left: 90px;
      }
      .el-header{
          width: 1200px;
          height:auto!important;
          padding: 20px 0;
          font-family: Arial;
          font-size: 24px;
          font-weight: 400;
          text-align: left;
          color: #353643;
          .logo {
            width: 309px;
            height: 69px;
            img{
              width:100%;
              height:100%;
            }
          }
          p {
            width: 309px;
            margin-top:10px;
            text-align: center;
          }
      }
    }
    .reset_form{
      width:385px;
      margin: 0 auto;
      background: #fff;
      border-radius: 16px;
      box-shadow: 0px 4px 6px -4px rgba(0, 0, 0, 0.1),0px 10px 15px -3px rgba(0, 0, 0, 0.1);
      padding: 40px;
        .el-form {
        width: 100%;
        /deep/ .el-form-item{
              margin-bottom:30px;
            .el-form-item__content{
              display: flex;
              margin:0!important;
              img{
                width: 20px;
                height:20px;
                margin: 0 10px;
                position: absolute;
                right: 0px;
                bottom:12px;
              }
              .el-input{
                border: 1px solid #E5E7EB;
                border-radius: 2px 8px 8px 2px;
                margin-top: 8px;
              }
              .errorPass{
                //border-bottom: 1px solid #fc424c;
              }
              .el-input__inner {
                -moz-appearance: none;
                width:100%;
                height: 40px;
                border:none;
                background: none;
                font-size: 16px;
                color: #353643;
                font-family: Arial;
                letter-spacing: 0px;
                outline: 0;
                padding:0 40px 0 0;
                border-radius: 0;
              }
              .el-form-item__error{
                font-size: 14px;
                color: #fc424c;
                font-family: Arial;
                width: max-content;
              }
            }
          }
        .password_look_list{
          width: 100%;
          display: flex;
          border-bottom: 1px solid #a5a5a5;
          img{
            width: 24px;
            height:24px;
            margin: 0 10px;
          }
        }
        button{
          width: 100%;
          height: 40px;
          background: #FF904D;
          border-radius: 4px;
          border:1px solid #FF904D;
          color:#fff;
          font-size: 16px;
          font-family: Arial;
        }
        .borderBtn{
            width:auto;
            height: 40px;
            background: #ffffff;
            border: 2px solid #FF904D;
            border-radius: 7px;
            font-size: 14px;
            font-family: Arial;
            font-weight: 700;
            color: #FF904D;
            margin: 0 20px;
            &:hover{
              background: #ffffff;
              border: 2px solid #FF904D;
              font-size: 14px;
              font-family: Arial;
              font-weight: 700;
              color: #FF904D;
            }
        }
        p{
          //margin-top:30px;
        }
        input{
          width:345px;
          height: 50px;
          border:none;
          background: none;
          font-size: 18px;
          color: #353643;
          font-family: Arial;
          letter-spacing: 0px;
        }
        input:focus {
          outline: none;
        }
      }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/resetPassword.vue